/**
 * The URL path from where the mediaplayer is located.
 */
let mediaplayerPath: string;

/**
 * The URL path used for generating a token for the mediaplayer.
 */
let mediaplayerTokenPath: string;

let video23Path: string;

switch (process.env.APP_ENV ?? process.env.NODE_ENV) {
    case "production":
        mediaplayerPath = (
            "https://medialibrary.gyldendal.dk/MediaPlayer/1.11/Player.html"
        );

        mediaplayerTokenPath = (
            "https://medialibrary.gyldendal.dk/api/token"
        );

        video23Path = "https://gyldendalprodukter.videomarketingplatform.co";
        break;

    case "staging":
        mediaplayerPath = (
            "https://medialibrary.gyldendal.dk/MediaPlayer/1.11/Player.html"
        );

        mediaplayerTokenPath = (
            "https://medialibrary.gyldendal.dk/api/token"
        );

        video23Path = "https://test-player-mediaprovider.gyldendal.dk";
        break;

    default:
        mediaplayerPath = (
            "https://test-medialibrary.gyldendal.dk/MediaPlayer/1.11/Player.html"
        );

        mediaplayerTokenPath = (
            "https://test-medialibrary.gyldendal.dk/api/token"
        );

        video23Path = "https://test-player-mediaprovider.gyldendal.dk";

}

export const urls = {
    mediaplayerPath,
    mediaplayerTokenPath,
    video23Path
};
